// Icon: material-symbols:keep-outline-rounded
// Slug: Persists signals in local storage.
// Description: Persists signals in local storage.

import { attribute } from '@engine'
import { effect, filtered, mergePatch } from '@engine/signals'
import type { SignalFilterOptions } from '@engine/types'

attribute({
  name: 'persist',
  returnsValue: true,
  apply({ key, mods, rx }) {
    const storageKey = key || 'datastar'
    const storage = mods.has('session') ? sessionStorage : localStorage

    // Load from storage after current execution cycle
    const fromStorage = storage[storageKey]
    if (fromStorage) {
      try {
        const parsed = JSON.parse(fromStorage)
        mergePatch(parsed)
      } catch (e) {
        console.error('Failed to parse persisted data:', e)
      }
    }

    return effect(() => {
      const toStore = filtered(rx?.() as SignalFilterOptions)
      const json = JSON.stringify(toStore)
      storage[storageKey] = json
    })
  },
})
